import { syncStatusTypeEnumList } from '../../../components/AgGrid/enumLists'

const syncStatusTypeValueGetter = (props) => {
  const { value } = props
  return syncStatusTypeEnumList(value)
}

export default syncStatusTypeValueGetter
